import React, { useState, useEffect, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment'
import HttpService from '../../../services/httpService'
import { setSnackInfo } from '../../../redux/actions/appAction'
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TablePagination from '@material-ui/core/TablePagination';
import Tooltip from '@material-ui/core/Tooltip';
import Slide from '@material-ui/core/Slide';
import {
    Button, Box, Grid, Dialog, DialogContent, DialogActions, TextField, Select, InputLabel,
    MenuItem, Checkbox, Switch, IconButton, InputAdornment, CircularProgress, Chip,
} from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import { Autocomplete } from '@material-ui/lab';
import { ROLENAME } from '../../../utils';
// Material-UI icons throughout - the Ant Design set these replace was the odd
// one out against every other page in the app, and read as dated beside them.
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
import AddIcon from '@material-ui/icons/Add';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import CloseIcon from '@material-ui/icons/Close';
import InboxOutlinedIcon from '@material-ui/icons/InboxOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import RefreshIcon from '@material-ui/icons/Refresh';
import LinearProgress from '@material-ui/core/LinearProgress';
import Skeleton from '@material-ui/lab/Skeleton';

const ORANGE = "#F47E44";
const ORANGE_DARK = "#c1531f";
const ORANGE_LIGHT = "#fff1ea";
const HEADER_GRADIENT = `linear-gradient(135deg, ${ORANGE_DARK} 0%, ${ORANGE} 60%, #ff9c66 100%)`;
const RED = "#c0392b";
const RED_LIGHT = "#fdecea";
const HEADING_FONT = "'Silka bold', 'Silka semiBold', sans-serif !important";

// Warm, on-brand palette for the per-team avatar chips - cycled by index
const AVATAR_COLORS = [
    { bg: "#fff1ea", fg: "#c1531f" },
    { bg: "#fff4d6", fg: "#b8860b" },
    { bg: "#e8f6ef", fg: "#1e8a5f" },
    { bg: "#eaf1ff", fg: "#2c5fb8" },
    { bg: "#f5ecff", fg: "#7b3fd6" },
    { bg: "#ffeaf1", fg: "#c1315f" },
];

const getAvatarColor = (name = "") => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Indeterminate bar shown while the list is being fetched. Same treatment as
// the Departments / Experience Centers / Locations pages, which share this
// orange palette, so they read as one system.
const BrandLinearProgress = withStyles(() => ({
    root: { height: 4, borderRadius: 999, backgroundColor: "rgba(193,83,31,0.10)" },
    bar: { borderRadius: 999, background: `linear-gradient(90deg, ${ORANGE_DARK}, ${ORANGE}, #ff9c66)` },
}))(LinearProgress);

const OrangeSwitch = withStyles({
    switchBase: {
        color: "#ccc",
        '&$checked': {
            color: ORANGE,
        },
        '&$checked + $track': {
            backgroundColor: ORANGE,
        },
    },
    checked: {},
    track: {},
})(Switch);

const useStyles = makeStyles({
    page: {
        padding: "4px 2px 24px",
    },
    headerCard: {
        position: "relative",
        background: HEADER_GRADIENT,
        borderRadius: 18,
        padding: "24px 28px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 16,
        marginBottom: 20,
        boxShadow: "0 10px 28px rgba(244, 126, 68, 0.3)",
        overflow: "hidden",
    },
    headerGlowOne: {
        position: "absolute",
        top: -60,
        right: -40,
        width: 180,
        height: 180,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.12)",
        pointerEvents: "none",
    },
    headerGlowTwo: {
        position: "absolute",
        bottom: -70,
        right: 120,
        width: 140,
        height: 140,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.08)",
        pointerEvents: "none",
    },
    headerLeft: {
        display: "flex",
        alignItems: "center",
        gap: 16,
        flexWrap: "wrap",
        position: "relative",
        zIndex: 1,
    },
    iconBadge: {
        width: 56,
        height: 56,
        borderRadius: 16,
        background: "rgba(255,255,255,0.22)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 28,
        color: "#fff",
        flexShrink: 0,
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.25)",
    },
    headerTitle: {
        color: "#fff",
        fontFamily: HEADING_FONT,
        fontSize: 23,
        margin: 0,
    },
    headerSubtitle: {
        color: "rgba(255,255,255,0.88)",
        fontSize: 13,
        margin: "4px 0 0",
    },
    statChip: {
        background: "rgba(255,255,255,0.22)",
        color: "#fff",
        fontWeight: 600,
        fontSize: 13,
        height: 30,
    },
    // Deliberately NOT the usual red: on this orange banner a red chip is both
    // low-contrast and easy to read as decoration. A solid dark fill with white
    // text separates it from the translucent stat chips beside it.
    warnChip: {
        background: "rgba(0,0,0,0.32)",
        color: "#fff",
        fontWeight: 700,
        fontSize: 13,
        height: 30,
        border: "1px solid rgba(255,255,255,0.45)",
        cursor: "help",
    },
    // All three header buttons share the solid white treatment.
    refreshBtn: {
        background: "#fff",
        color: ORANGE_DARK,
        fontWeight: 700,
        borderRadius: 10,
        textTransform: "none",
        padding: "9px 22px",
        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
        transition: "transform .15s ease",
        "&:hover": {
            background: "#fff1ea",
            transform: "translateY(-1px)",
        },
        // Refresh is the only one of the three that disables, so it needs a
        // state that still reads as white rather than going grey on the banner.
        "&.Mui-disabled": {
            background: "rgba(255,255,255,0.8)",
            color: ORANGE_DARK,
            boxShadow: "none",
        },
    },
    spin: { animation: "$spin 0.9s linear infinite" },
    "@keyframes spin": {
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" },
    },
    lastUpdatedText: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 6,
        fontSize: 12,
        fontWeight: 600,
        color: "rgba(255,255,255,0.92)",
    },
    liveDot: {
        width: 7,
        height: 7,
        borderRadius: "50%",
        background: "#8ef5b5",
        boxShadow: "0 0 0 3px rgba(142,245,181,0.25)",
    },
    // Always occupies the bar's height, whether or not the bar is showing.
    progressSlot: { height: 4, marginBottom: 10 },
    loadingBanner: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "9px 14px",
        marginBottom: 14,
        borderRadius: 12,
        background: ORANGE_LIGHT,
        border: `1px solid ${ORANGE}33`,
    },
    loadingBannerTitle: { fontSize: 13, fontWeight: 700, color: ORANGE_DARK },
    loadingBannerHint: { fontSize: 11.5, color: "#7a6a60", marginTop: 1 },
    headerActions: {
        display: "flex",
        gap: 10,
        flexWrap: "wrap",
        // Without these the three buttons sat top-aligned and ragged once the
        // timestamp line was added below them.
        alignItems: "center",
        justifyContent: "flex-end",
        position: "relative",
        zIndex: 1,
    },
    addBtn: {
        background: "#fff",
        color: ORANGE_DARK,
        fontWeight: 700,
        borderRadius: 10,
        textTransform: "none",
        padding: "9px 22px",
        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
        transition: "transform .15s ease",
        "&:hover": {
            background: "#fff1ea",
            transform: "translateY(-1px)",
        },
    },
    updateBtn: {
        background: "#fff",
        color: ORANGE_DARK,
        fontWeight: 700,
        borderRadius: 10,
        textTransform: "none",
        padding: "9px 22px",
        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
        transition: "transform .15s ease",
        "&:hover": {
            background: "#fff1ea",
            transform: "translateY(-1px)",
        },
    },
    filterCard: {
        background: "#fff",
        borderRadius: 16,
        padding: "16px 20px",
        marginBottom: 20,
        boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
        display: "flex",
        alignItems: "center",
        gap: 14,
        flexWrap: "wrap",
    },
    sectionLabel: {
        fontSize: 12,
        fontWeight: 700,
        color: "#8a8a8a",
        textTransform: "uppercase",
        letterSpacing: 0.5,
        marginRight: 4,
    },
    searchField: {
        width: 260,
        "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            "&.Mui-focused fieldset": {
                borderColor: ORANGE,
            },
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: ORANGE_DARK,
        },
    },
    departmentFilter: {
        width: 260,
        "& .MuiOutlinedInput-root": {
            borderRadius: 10,
        },
    },
    clearBtn: {
        color: ORANGE_DARK,
        textTransform: "none",
        fontWeight: 600,
    },
    resultCount: {
        marginLeft: "auto",
        fontSize: 13,
        color: "#999",
    },
    rowHint: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        color: "#aaa",
        marginBottom: 8,
        marginLeft: 4,
    },
    tableCard: {
        borderRadius: 18,
        overflow: "hidden",
        boxShadow: "0 2px 14px rgba(0,0,0,0.07)",
    },
    tableScrollWrap: {
        maxHeight: "calc(100vh - 480px)",
        minHeight: 160,
        overflow: "auto",
    },
    table: {
        minWidth: 1100,
    },
    tableHeadCell: {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: ORANGE_DARK,
        color: "#fff",
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: 0.3,
        border: "none",
        whiteSpace: "nowrap",
    },
    sortLabel: {
        color: "#fff !important",
        "&:hover": {
            color: "#fff !important",
        },
        "& .MuiTableSortLabel-icon": {
            color: "#fff !important",
        },
    },
    tableRow: {
        cursor: "pointer",
        position: "relative",
        "&:nth-of-type(odd)": {
            backgroundColor: "#fbfbfb",
        },
        "&:hover": {
            backgroundColor: ORANGE_LIGHT,
            boxShadow: "inset 3px 0 0 0 " + ORANGE,
        },
        transition: "background-color .15s ease, box-shadow .15s ease",
    },
    tableCell: {
        fontSize: 14,
        color: "#333",
        whiteSpace: "nowrap",
    },
    nameCell: {
        display: "flex",
        alignItems: "center",
        gap: 10,
    },
    avatarChip: {
        width: 34,
        height: 34,
        borderRadius: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: 14,
        flexShrink: 0,
        transition: "transform .15s ease",
        "$tableRow:hover &": {
            transform: "scale(1.08) rotate(-4deg)",
        },
    },
    roleChip: {
        height: 24,
        fontSize: 12,
        fontWeight: 600,
        transition: "transform .15s ease",
        "&:hover": { transform: "scale(1.05)" },
    },
    managerChip: {
        backgroundColor: "#eaf1ff",
        color: "#2c5fb8",
    },
    agmChip: {
        backgroundColor: "#f5ecff",
        color: "#7b3fd6",
    },
    dgmChip: {
        backgroundColor: "#e8f6ef",
        color: "#1e8a5f",
    },
    naText: {
        color: "#ccc",
        fontSize: 13,
    },
    viewBtn: {
        color: ORANGE_DARK,
        backgroundColor: ORANGE_LIGHT,
        transition: "transform .15s ease, background-color .15s ease",
        "&:hover": { backgroundColor: "#ffe3d2", transform: "scale(1.15)" },
    },
    emptyState: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "64px 20px",
        color: "#9b9b9b",
        background: "#fff",
    },
    emptyIcon: {
        fontSize: 46,
        color: "#e0b8a4",
        marginBottom: 12,
    },
    emptyTitle: {
        fontSize: 15,
        fontWeight: 600,
        color: "#666",
    },
    emptyHint: {
        fontSize: 13,
        color: "#aaa",
        marginTop: 4,
    },
    pagination: {
        borderTop: "1px solid #f0f0f0",
    },
    dialogHeader: {
        background: HEADER_GRADIENT,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "18px 24px",
    },
    dialogTitleWrap: {
        display: "flex",
        alignItems: "center",
        gap: 10,
    },
    dialogIconBadge: {
        width: 34,
        height: 34,
        borderRadius: 10,
        background: "rgba(255,255,255,0.22)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 17,
    },
    dialogTitleText: {
        fontFamily: HEADING_FONT,
        fontSize: 18,
    },
    dialogCloseBtn: {
        color: "#fff",
    },
    dialogContent: {
        padding: "26px 24px 10px",
    },
    dialogLoadingRow: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 14,
        padding: "7px 12px",
        borderRadius: 10,
        background: ORANGE_LIGHT,
        border: `1px solid ${ORANGE}33`,
        fontSize: 12.5,
        fontWeight: 600,
        color: ORANGE_DARK,
    },
    inputField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            "&.Mui-focused fieldset": {
                borderColor: ORANGE,
            },
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: ORANGE_DARK,
        },
    },
    submitBtn: {
        background: HEADER_GRADIENT,
        color: "#fff",
        fontWeight: 600,
        textTransform: "none",
        borderRadius: 10,
        padding: "8px 22px",
        "&:hover": {
            background: HEADER_GRADIENT,
            opacity: 0.92,
        },
    },
    cancelBtn: {
        color: "#666",
        textTransform: "none",
        fontWeight: 600,
    },
    viewUserRow: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "8px 4px",
        borderBottom: "1px solid #f2f2f2",
    },
});

const StyledTableCell = withStyles(() => ({
    head: {
        border: "none",
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

// Shared markup for the "Select Location" / "Select Experience Center"
// multi-select checkboxes used in both the Add and Update dialogs.
const FormControlSelect = ({ classes, label, value, onChange, options }) => (
    <Box>
        <InputLabel style={{ fontSize: 13, marginBottom: 6 }}>{label}</InputLabel>
        <Select
            fullWidth
            multiple
            className={classes.inputField}
            variant="outlined"
            value={value}
            onChange={onChange}
            input={<Input />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
        >
            {options.map((name) => (
                <MenuItem key={name.name} value={name.name}>
                    <Checkbox checked={value.indexOf(name.name) > -1} />
                    <ListItemText primary={name.name} />
                </MenuItem>
            ))}
        </Select>
    </Box>
);

const ManageTeam = (props) => {
    const classes = useStyles();
    const LoggedInUserDetails = useSelector(state => state.user);
    const [departments, setDepartmentsLists] = useState([]);
    const [departmentName, setDepartmentName] = useState("");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [teamModal, setAddTeamModal] = React.useState(false);
    const [updateteamModal, setupdateTeamModal] = React.useState(false);

    const [teamList, setTeamLists] = useState([])
    const [teamName, setTeamName] = useState("");
    const [viewTeamsUser, SetViewTeamUsers] = React.useState(false);
    const [teamUserList, setTeamUserList] = useState([])
    const [selectedCities, setSelectedCities] = useState([]);
    const [dumpCities, setDumpCities] = useState([]);
    const [expcenters, setExpcenters] = useState([]);
    const [dumpExpCenters, setDumpExpcenters] = useState([]);
    const [selectedExpcenters, setSelectedExpcenters] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState("")
    const [allManagers, setAllManagers] = useState([])
    const [filteredAGM, setFilteredAGM] = useState([])
    const [selectedManager, setSelectedManager] = useState("")
    const [filteredManagers, setFilteredManagers] = useState([])
    const [FilteredDGM, setFilteredDGM] = useState([])
    const [selectedAGM, setSelectedAGM] = useState("")
    const [selectedDGM, setSelectedDGM] = useState("")
    const [departmentsFilter, setDepartmentsFilter] = useState([]);

    const [dataLoading, setDataLoading] = useState(false);
    const [savingTeam, setSavingTeam] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    // When the list on screen was last pulled. Only set on a SUCCESSFUL fetch,
    // so a failed refresh never makes stale rows look fresh.
    const [lastUpdated, setLastUpdated] = useState(null);
    // "Updated 4 minutes ago" is only true at the instant it renders, so a slow
    // tick re-renders it. 30s is plenty - moment rounds to the minute anyway.
    const [nowTick, setNowTick] = useState(Date.now());
    // Reference data for the Add/Update dialogs (managers, departments,
    // locations, experience centres). A COUNTER, not a boolean: all four fetch
    // concurrently on mount, and a boolean would be cleared by whichever
    // finished first while the other three were still in flight.
    const [refDataPending, setRefDataPending] = useState(0);
    const refDataLoading = refDataPending > 0;
    // Which team's Active switch is mid-request, so only that row spins
    // instead of locking the whole page behind the global loader.
    const [togglingTeamId, setTogglingTeamId] = useState(null);

    useEffect(() => {
        const id = setInterval(() => setNowTick(Date.now()), 30000)
        return () => clearInterval(id)
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Only changes the page size/index - this used to also reset the team
    // list to the number 0 here, which would have crashed the table the
    // moment anyone changed rows-per-page (0.map is not a function).
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    useEffect(() => {
        // getTeams owns setDataLoading itself now, so no wrapper here.
        getTeams();
        getLocationList();
        getExperienceCenters();
        getAllManagers();
        fetchDepartments();
        // eslint-disable-next-line
    }, [])


    const getAllManagers = async () => {
        setRefDataPending((n) => n + 1)
        try {
            const response = await HttpService.getUsers();
            setAllManagers(response.data);
        } catch (error) {
            console.error(error, "get department error")
        }
        setRefDataPending((n) => n - 1)
    }

    const getDepartments = async () => {
        setRefDataPending((n) => n + 1)
        try {
            const department = await HttpService.getDepartments();
            setDepartmentsLists(department.data);
        } catch (error) {
            console.error(error, "get department error")
        }
        setRefDataPending((n) => n - 1)
    }

    const getTeams = async () => {
        // Owns the table's own flag now, rather than relying on every caller to
        // wrap it - the bar, the banner and the Refresh button all read this.
        setDataLoading(true);
        try {

            const isAuthUser = LoggedInUserDetails?.userDetails?.roles?.some(
                r => ["LnD_User", "Admin", "Naraci Tech Manager", "Naraci Tech User", "HR User", "HR Manager"].includes(r?.name)
            );

            const payload = isAuthUser
                ? {}
                : {
                    departmentId: LoggedInUserDetails?.userDetails?.departmentId,
                    experienceCenterId: JSON.stringify(LoggedInUserDetails?.userDetails?.experienceCenterId),
                };

            const team = await HttpService.getTeams(payload);

            setTeamLists(team.data);
            // Inside the try, after the assignment: a fetch that threw leaves
            // the previous timestamp alone rather than vouching for stale data.
            setLastUpdated(moment());
        } catch (error) {
            console.error(error, "get department error")
        }
        setDataLoading(false)
    }

    const filterteams = async (event, values) => {
        setDataLoading(true);
        try {
            const selectedName = values?.[0]?.name;
            if (selectedName) {
                const filtered =
                    teamList.filter(
                        row =>
                            row.isActive &&
                            row?.departmentId?.name?.toString() === selectedName.toString()
                    );
                setTeamLists(filtered);
            } else {

                const team = await HttpService.getTeams({});
                setTeamLists(team.data);
            }
        } catch (error) {
            console.error(error, "get filterteams error");
        }

        setDataLoading(false);
    };

    const [cities, setCities] = useState([]);

    const openAddTeamModal = () => {
        setAddTeamModal(true);
        getDepartments()
    }
    const openupdateTeamModal = () => {
        setupdateTeamModal(true);
        getDepartments()
    }
    const handleTeamModalClose = () => {
        setAddTeamModal(false);
        setupdateTeamModal(false);
    };

    const filterManager = (department) => {
        let arr = allManagers.filter((user) => {
            const bool1 = user?.departmentId?.name === department?.name
            const bool2 = user?.roles?.find((role) => role?.name?.includes("Manager"))
            return bool1 && bool2
        })
        if (arr.length == 0) {
            arr = allManagers.filter((user) => {
                return user?.roles?.find((role) => role?.name?.includes("Manager"));
            })
        }
        setFilteredManagers(arr);
    }

    const filterDGM = (department) => {
        let arr = allManagers.filter((user) => {
            const bool1 = user?.departmentId?.name === department?.name
            const bool2 = user?.roles?.find((role) => role?.name?.includes("DGM"))
            return bool1 && bool2
        })
        if (arr.length == 0) {
            arr = allManagers.filter((user) => {
                return user?.roles?.find((role) => role?.name?.includes("DGM"));
            })
        }
        setFilteredDGM(arr);
    }

    // Takes the team object directly (rather than an index into the raw,
    // unfiltered teamList) so this stays correct once the table is
    // searched/sorted/paginated and no longer renders teamList 1:1.
    const openTeamViewModal = (team) => {
        SetViewTeamUsers(true);
        setTeamName(team?.name);
        const activeTeamUsers = (team?.users || []).filter(user => user?.isActive === true);
        setTeamUserList(activeTeamUsers);
    }

    const handleViewTeamModalClose = () => {
        SetViewTeamUsers(false);
    };

    const saveTeam = async () => {
        let selectedLocation = [];
        let selectedCenter = [];

        cities.forEach((ele, i) => {
            if (selectedCities.includes(ele.name)) {
                selectedLocation.push(ele._id)
            }
        })

        expcenters.forEach((ele, i) => {
            if (selectedExpcenters.includes(ele.name)) {
                selectedCenter.push(ele._id)
            }
        })
        try {
            setSavingTeam(true)
            let data = {
                name: teamName,
                departmentId: departmentName._id,
                locationId: selectedLocation,
                experienceCenterId: selectedCenter,
            }
            if (selectedManager != null) {
                data.manager = selectedManager._id;
            }
            await HttpService.createTeam(data);
            props.setSnackInfo('Team Added Successfully', 'success')
            setTeamName('');
            getTeams();
            setAddTeamModal(false);
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        setSavingTeam(false)
    }
    const filterAGM = (department) => {
        let arr = allManagers.filter((user) => {
            const bool1 = user?.departmentId?.name === department?.name
            const bool2 = user?.roles?.find((role) => role?.name?.includes("AGM"))
            return bool1 && bool2
        })
        if (arr.length == 0) {
            arr = allManagers.filter((user) => {
                return user?.roles?.find((role) => role?.name?.includes("AGM"));
            })
        }
        setFilteredAGM(arr);
    }


    const getLocationList = async () => {
        setRefDataPending((n) => n + 1)
        try {
            const response = await HttpService.getLocationList()
            let citi = []
            response.data.forEach((ele, i) => {
                citi.push({
                    name: ele.name
                })
            })
            setDumpCities(citi)
            setCities(response.data)
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        setRefDataPending((n) => n - 1)
    }

    const getExperienceCenterByLocation = (e) => {
        setSelectedCities(e.target.value)
        let expcenter = [];
        let existingSelected = [];
        expcenters?.forEach((ele, i) => {
            if (e.target.value.includes(ele?.locationId?.name)) {
                expcenter.push({
                    name: ele?.name
                })
            }
            if (e.target.value.includes(ele.locationId.name)) {
                selectedExpcenters?.forEach((ele1, i) => {
                    if (ele1 === ele?.name) {
                        existingSelected.push(ele.name)
                    }
                })
            }
        })
        setDumpExpcenters(expcenter)
        setSelectedExpcenters(existingSelected)
    }

    const getExperienceCenters = async () => {
        setRefDataPending((n) => n + 1)
        try {
            const response = await HttpService.getExpericenCenters()
            setExpcenters(response.data)
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        setRefDataPending((n) => n - 1)
    }

    const getSelectedExpCenters = (e) => {
        setSelectedExpcenters(e.target.value);
    }

    const isActiveTeam = async (teamId) => {
        setTogglingTeamId(teamId)
        try {
            const response = await HttpService.deactivateTeam(teamId)
            props.setSnackInfo(response?.data ?? "Team Updated Successfully", "success")
            // Awaited, so the row stays in its pending state until the list it
            // refreshes has actually landed - otherwise the switch snaps back
            // to its old position for a moment before the new data arrives.
            await getTeams();
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        setTogglingTeamId(null)
    }

    const updateTeam = async () => {
        let selectedLocation = [];
        let selectedCenter = [];

        cities.forEach((ele, i) => {
            if (selectedCities.includes(ele.name)) {
                selectedLocation.push(ele._id)
            }
        })

        expcenters.forEach((ele, i) => {
            if (selectedExpcenters.includes(ele.name)) {
                selectedCenter.push(ele._id)
            }
        })
        try {
            setSavingTeam(true)
            let data = {
                name: teamName,
                teamId: selectedTeam._id,
                locationId: selectedLocation,
                experienceCenterId: selectedCenter
            }
            if (selectedManager != null) {
                data.manager = selectedManager._id;
            }
            if (selectedManager != null) {
                data.manager = selectedManager._id;
            }
            if (selectedDGM != null) {
                data.DGM = selectedDGM._id;
            }

            if (selectedAGM != null) {
                data.AGM = selectedAGM._id;
            }

            await HttpService.editTeam(data);
            props.setSnackInfo('Team Updated Successfully', 'success')
            setTeamName('');
            setSelectedTeam("")
            setSelectedManager("")
            setSelectedDGM("")
            setSelectedAGM("")
            getTeams();
            setupdateTeamModal(false);
            // setTimeout(() => {
            //     window.location.reload()
            // },1000)
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        setSavingTeam(false)
    }
    const setSelectedTeamvalues = (e) => {
        setSelectedTeam(e.target.value)
        let value = teamList.find(ele => ele._id === e.target.value?._id)
        setTeamName(value.name)
        let selectedLocation = [];
        let selectedCenter = [];

        value.locationId.forEach((ele, i) => {
            selectedLocation.push(ele.name)
        })

        value.experienceCenterId.forEach((ele, i) => {
            selectedCenter.push(ele.name)
        })
        setSelectedCities(selectedLocation)
        setSelectedExpcenters(selectedCenter)

        const inputString = e.target.value.name;
        // Split the string into an array of words using whitespace as the delimiter
        const words = inputString.split(/\s+/);
        const department = words[0];

        let arr = allManagers.filter((user) => {
            const bool1 = user?.departmentId?.name === department
            const bool2 = user?.roles?.find((role) => role?.name?.includes("Manager"))
            return bool1 && bool2
        })
        if (arr.length == 0) {
            arr = allManagers.filter((user) => {
                return user?.roles?.find((role) => role?.name?.includes("Manager"));
            })
        }
        setFilteredManagers(arr);

        let dgmArr = allManagers.filter((user) => {
            const bool1 = user?.departmentId?.name === department
            const bool2 = user?.roles?.find((role) => role?.name?.includes("DGM"))
            return bool1 && bool2
        })
        if (dgmArr.length == 0) {
            dgmArr = allManagers.filter((user) => {
                return user?.roles?.find((role) => role?.name?.includes("DGM"));
            })
        }
        setFilteredDGM(dgmArr);

        let AgmArr = allManagers.filter((user) => {
            const bool1 = user?.departmentId?.name === department
            const bool2 = user?.roles?.find((role) => role?.name?.includes("AGM"))
            return bool1 && bool2
        })
        if (AgmArr.length == 0) {
            AgmArr = allManagers.filter((user) => {
                return user?.roles?.find((role) => role?.name?.includes("AGM"));
            })
        }
        setFilteredAGM(AgmArr);

    }

    const setSelectedTeamManagervalue = (e) => {
        setSelectedManager(e.target.value)
    }
    const setSelectedTeamDgmValue = (e) => {
        setSelectedDGM(e.target.value)
    }
    const setSelectedTeamAgmValue = (e) => {
        setSelectedAGM(e.target.value)
    }

    const fetchDepartments = async () => {
        try {
            let res = await HttpService.getDepartments();
            setDepartmentsFilter(res.data);
        } catch (error) {
            props.setSnackInfo(error, "something went wrong")
        }
    };

    const toggleSort = () => {
        setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
    };

    const filteredList = useMemo(() => {
        let list = [...teamList]
        if (searchText.trim()) {
            const q = searchText.trim().toLowerCase()
            list = list.filter((row) =>
                row?.name?.toLowerCase().includes(q) ||
                row?.departmentId?.name?.toLowerCase().includes(q) ||
                row?.manager?.name?.toLowerCase().includes(q)
            )
        }
        list.sort((a, b) => {
            const cmp = (a?.name || "").localeCompare(b?.name || "")
            return sortOrder === "asc" ? cmp : -cmp
        })
        return list
    }, [teamList, searchText, sortOrder]);

    const paginatedList = useMemo(() => {
        const start = page * rowsPerPage
        return filteredList.slice(start, start + rowsPerPage)
    }, [filteredList, page, rowsPerPage]);

    useEffect(() => {
        setPage(0)
    }, [searchText]);

    const activeCount = useMemo(() => teamList.filter((t) => t?.isActive).length, [teamList]);

    // Factual, straight off the rows - a team with nobody tagged as manager is
    // not rejected anywhere, but it is unassigned leadership and the "NA" in
    // the Manager column is easy to scroll past. Named here, counted once.
    const noManagerCount = useMemo(
        () => teamList.filter((t) => !t?.manager?.name).length,
        [teamList]
    );


    return (
        <div className={classes.page}>
            <div className={classes.headerCard}>
                <div className={classes.headerGlowOne} />
                <div className={classes.headerGlowTwo} />
                <div className={classes.headerLeft}>
                    <div className={classes.iconBadge}>
                        <GroupOutlinedIcon />
                    </div>
                    <div>
                        <h2 className={classes.headerTitle}>Teams</h2>
                        <p className={classes.headerSubtitle}>Manage sales/ops teams, their leadership and coverage</p>
                    </div>
                    <Chip className={classes.statChip} icon={<GroupOutlinedIcon style={{ color: "#fff" }} />} label={`${teamList.length} Team${teamList.length === 1 ? "" : "s"}`} />
                    <Chip className={classes.statChip} icon={<CheckCircleOutlineIcon style={{ color: "#fff" }} />} label={`${activeCount} Active`} />
                    {/* Only when there is something to report - a permanent
                        "0 without a manager" chip would become background noise. */}
                    {noManagerCount > 0 && (
                        <Tooltip title="These teams have nobody tagged as manager, so they show NA in the Manager column and have no named owner for anything routed by team leadership.">
                            <Chip
                                className={classes.warnChip}
                                icon={<ReportProblemOutlinedIcon style={{ color: "#fff" }} />}
                                label={`${noManagerCount} without a manager`}
                            />
                        </Tooltip>
                    )}
                </div>
                <div className={classes.headerActions}>
                    <Tooltip
                        title={
                            lastUpdated
                                ? `Last loaded at ${lastUpdated.format("DD MMM YYYY, hh:mm:ss A")} — click to reload`
                                : "Reload the teams"
                        }
                    >
                        {/* A disabled button fires no mouse events, so the
                            tooltip would die exactly when it is most wanted -
                            mid-refresh. */}
                        <span style={{ display: "inline-flex" }}>
                            <Button
                                className={classes.refreshBtn}
                                onClick={getTeams}
                                disabled={dataLoading}
                                startIcon={<RefreshIcon className={dataLoading ? classes.spin : ""} />}
                            >
                                {dataLoading ? "Refreshing…" : "Refresh"}
                            </Button>
                        </span>
                    </Tooltip>
                    <Button className={classes.updateBtn} startIcon={<EditOutlinedIcon />} onClick={openupdateTeamModal}>
                        Update Team
                    </Button>
                    <Button className={classes.addBtn} startIcon={<AddIcon />} onClick={openAddTeamModal}>
                        Add Team
                    </Button>
                    {/* LAST, not between the buttons: lastUpdatedText is
                        width:100%, so in the middle of a wrapping flex row it
                        took a line of its own and pushed the button after it
                        onto a third row. At the end it simply sits under the
                        button group, which is where it belongs. */}
                    {lastUpdated && (
                        <div className={classes.lastUpdatedText}>
                            <span className={classes.liveDot} />
                            {dataLoading ? "Loading…" : `Updated ${moment(lastUpdated).from(nowTick)}`}
                        </div>
                    )}
                </div>
            </div>

            <div className={classes.filterCard}>
                <span className={classes.sectionLabel}>Search</span>
                <TextField
                    className={classes.searchField}
                    size="small"
                    variant="outlined"
                    placeholder="Search by team, department or manager"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon style={{ color: "#aaa" }} />
                            </InputAdornment>
                        ),
                    }}
                />
                {LoggedInUserDetails?.userDetails?.roles.find((role) => role.name === ROLENAME.LnDManager || role.name === ROLENAME.LnDUser || role.name === ROLENAME.Admin || role.name === ROLENAME.NaraciTechManager || role.name === ROLENAME.NaraciTechUser || role.name === ROLENAME.HRUser || role.name === ROLENAME.HRManager) && (
                    <>
                        <span className={classes.sectionLabel}>Department</span>
                        <Autocomplete
                            multiple
                            id="department-autocomplete"
                            className={classes.departmentFilter}
                            size="small"
                            options={departmentsFilter}
                            getOptionLabel={(option) => option?.name}
                            onChange={filterteams}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Departments"
                                />
                            )}
                        />
                    </>
                )}
                {searchText && (
                    <Button
                        className={classes.clearBtn}
                        size="small"
                        startIcon={<ClearAllIcon />}
                        onClick={() => setSearchText("")}
                    >
                        Clear
                    </Button>
                )}
                <span className={classes.resultCount}>
                    {filteredList.length} of {teamList.length} shown
                </span>
            </div>

            {teamList.length > 0 && (
                <div className={classes.rowHint}>
                    <VisibilityOutlinedIcon style={{ fontSize: 12 }} /> Click any row to view its members
                </div>
            )}

            {/* Reserved slot rather than a conditional element, so starting a
                fetch does not jog the table down by 4px and back again. */}
            <div className={classes.progressSlot}>
                {dataLoading ? <BrandLinearProgress /> : null}
            </div>

            {/* The bar alone says "something is happening"; this says WHAT,
                which matters most on a refresh - the rows stay on screen then,
                so without it there is nothing to explain why they have not
                changed yet. */}
            {dataLoading && (
                <div className={classes.loadingBanner}>
                    <CircularProgress size={17} thickness={5} style={{ color: ORANGE_DARK }} />
                    <div style={{ minWidth: 0 }}>
                        <div className={classes.loadingBannerTitle}>Fetching teams…</div>
                        <div className={classes.loadingBannerHint}>
                            {teamList.length
                                ? "Reloading the list — the teams below stay visible until the new data lands."
                                : "Pulling every team with its leadership and coverage."}
                        </div>
                    </div>
                </div>
            )}

            <Paper className={classes.tableCard}>
                {dataLoading && teamList.length === 0 ? (
                    // Placeholder rows shaped like real ones, so the card keeps
                    // its height and column rhythm instead of collapsing to a
                    // spinner and snapping back when the data lands. A REFRESH
                    // (list already populated) keeps the existing rows on screen
                    // rather than blanking them.
                    <TableContainer className={classes.tableScrollWrap}>
                        <Table className={classes.table} size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {["Sl No", "Team", "Department", "Status", "Manager", "AGM", "DGM", "Experience Center", "Location", "Members"].map((h) => (
                                        <StyledTableCell key={h} className={classes.tableHeadCell}>{h}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.from({ length: 8 }).map((_, i) => (
                                    <TableRow key={i}>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="text" width={20} /></StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}>
                                            <div className={classes.nameCell}>
                                                <Skeleton variant="circle" width={30} height={30} />
                                                <Skeleton variant="text" width={120} />
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="text" width={80} /></StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="rect" width={34} height={18} style={{ borderRadius: 999 }} /></StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="rect" width={84} height={22} style={{ borderRadius: 999 }} /></StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="rect" width={84} height={22} style={{ borderRadius: 999 }} /></StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="rect" width={84} height={22} style={{ borderRadius: 999 }} /></StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="text" width={100} /></StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="text" width={90} /></StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="circle" width={26} height={26} /></StyledTableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : filteredList.length === 0 ? (
                    <div className={classes.emptyState}>
                        <InboxOutlinedIcon className={classes.emptyIcon} />
                        <span className={classes.emptyTitle}>{searchText ? "No teams match your search" : "No teams added yet"}</span>
                        <span className={classes.emptyHint}>{searchText ? "Try a different name" : "Click \"Add Team\" to create the first one"}</span>
                    </div>
                ) : (
                    <>
                        <TableContainer className={classes.tableScrollWrap}>
                            <Table className={classes.table} size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell className={classes.tableHeadCell}>Sl No</StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell} sortDirection={sortOrder}>
                                            <TableSortLabel className={classes.sortLabel} active direction={sortOrder} onClick={toggleSort}>
                                                Team
                                            </TableSortLabel>
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell}>Department</StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell}>Status</StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell}>Manager</StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell}>AGM</StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell}>DGM</StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell}>Experience Center</StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell}>Location</StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell}>Members</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedList.map((row, i) => {
                                        const avatarColor = getAvatarColor(row?.name)
                                        return (
                                            <TableRow
                                                key={row?._id || i}
                                                className={classes.tableRow}
                                                onClick={() => openTeamViewModal(row)}
                                            >
                                                <StyledTableCell className={classes.tableCell}>{page * rowsPerPage + i + 1}</StyledTableCell>
                                                <StyledTableCell className={classes.tableCell}>
                                                    <div className={classes.nameCell}>
                                                        <div className={classes.avatarChip} style={{ backgroundColor: avatarColor.bg, color: avatarColor.fg }}>
                                                            {row?.name?.charAt(0)?.toUpperCase() || "?"}
                                                        </div>
                                                        {row?.name}
                                                    </div>
                                                </StyledTableCell>
                                                <StyledTableCell className={classes.tableCell}>{row?.departmentId?.name ?? "NA"}</StyledTableCell>
                                                <StyledTableCell className={classes.tableCell} onClick={(e) => e.stopPropagation()}>
                                                    {/* Only THIS row spins while its own toggle is in
                                                        flight - the page used to go behind the global
                                                        loader to flip one switch. Disabled meanwhile so
                                                        the same row cannot be toggled twice. */}
                                                    {togglingTeamId === row._id ? (
                                                        <CircularProgress size={18} style={{ color: ORANGE_DARK, margin: "0 9px" }} />
                                                    ) : (
                                                        <Tooltip title={row.isActive ? "Active - click to deactivate" : "Inactive - click to activate"}>
                                                            <OrangeSwitch
                                                                size="small"
                                                                checked={!!row.isActive}
                                                                disabled={!!togglingTeamId}
                                                                onChange={() => isActiveTeam(row._id)}
                                                            />
                                                        </Tooltip>
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell className={classes.tableCell}>
                                                    {row?.manager?.name ? (
                                                        <Chip size="small" label={row.manager.name} className={`${classes.roleChip} ${classes.managerChip}`} />
                                                    ) : (
                                                        <span className={classes.naText}>NA</span>
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell className={classes.tableCell}>
                                                    {row?.teamAGM?.name ? (
                                                        <Chip size="small" label={row.teamAGM.name} className={`${classes.roleChip} ${classes.agmChip}`} />
                                                    ) : (
                                                        <span className={classes.naText}>NA</span>
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell className={classes.tableCell}>
                                                    {row?.teamDGM?.name ? (
                                                        <Chip size="small" label={row.teamDGM.name} className={`${classes.roleChip} ${classes.dgmChip}`} />
                                                    ) : (
                                                        <span className={classes.naText}>NA</span>
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell className={classes.tableCell}>{row?.experienceCenterId?.[0]?.name ?? "NA"}</StyledTableCell>
                                                <StyledTableCell className={classes.tableCell}>{row?.locationId?.[0]?.name ?? "NA"}</StyledTableCell>
                                                <StyledTableCell className={classes.tableCell} onClick={(e) => e.stopPropagation()}>
                                                    <Tooltip title="View Team Members">
                                                        <IconButton size="small" className={classes.viewBtn} onClick={() => openTeamViewModal(row)}>
                                                            <VisibilityOutlinedIcon style={{ fontSize: 16 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </StyledTableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            className={classes.pagination}
                            component="div"
                            count={filteredList.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[50, 100, 200]}
                        />
                    </>
                )}
            </Paper>

            <Dialog open={teamModal} onClose={handleTeamModalClose} TransitionComponent={Transition} keepMounted fullWidth maxWidth="sm">
                <div className={classes.dialogHeader}>
                    <div className={classes.dialogTitleWrap}>
                        <div className={classes.dialogIconBadge}>
                            <GroupOutlinedIcon />
                        </div>
                        <span className={classes.dialogTitleText}>Add Team</span>
                    </div>
                    <IconButton size="small" className={classes.dialogCloseBtn} onClick={handleTeamModalClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <DialogContent className={classes.dialogContent}>
                    {/* The dropdowns below are populated by four separate
                        fetches. A thin bar inside the dialog says so, instead of
                        the whole page sitting behind the global loader. */}
                    {refDataLoading && (
                        <div className={classes.dialogLoadingRow}>
                            <CircularProgress size={14} thickness={5} style={{ color: ORANGE_DARK }} />
                            Loading departments, managers and coverage…
                        </div>
                    )}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                className={classes.inputField}
                                value={teamName}
                                onChange={(e) => setTeamName(e.target.value)}
                                label="Team Name"
                                type="text"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                className={classes.inputField}
                                value={departmentName}
                                label="Select Department"
                                onChange={(e) => {
                                    setDepartmentName(e.target.value);
                                    filterManager(e.target.value);
                                    filterDGM(e.target.value);
                                    filterAGM(e.target.value);
                                }}
                                variant="outlined"
                            >
                                {departments.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row}>{row?.name}</MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                className={classes.inputField}
                                value={selectedManager}
                                label="Select Team Manager"
                                onChange={setSelectedTeamManagervalue}
                                variant="outlined"
                            >
                                {filteredManagers.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row}>{row?.name}</MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                className={classes.inputField}
                                value={selectedDGM}
                                label="Select Team DGM"
                                onChange={setSelectedTeamDgmValue}
                                variant="outlined"
                            >
                                {FilteredDGM.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row}>{row?.name}</MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                className={classes.inputField}
                                value={selectedAGM}
                                label="Select Team AGM"
                                onChange={setSelectedTeamAgmValue}
                                variant="outlined"
                            >
                                {filteredAGM.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row}>{row?.name}</MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlSelect
                                classes={classes}
                                label="Select Location"
                                value={selectedCities}
                                onChange={getExperienceCenterByLocation}
                                options={dumpCities}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlSelect
                                classes={classes}
                                label="Select Experience Center"
                                value={selectedExpcenters}
                                onChange={getSelectedExpCenters}
                                options={dumpExpCenters}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ padding: "16px 24px 22px" }}>
                    <Button className={classes.cancelBtn} onClick={handleTeamModalClose}>Cancel</Button>
                    <Button
                        className={classes.submitBtn}
                        onClick={saveTeam}
                        disabled={savingTeam}
                        startIcon={savingTeam ? <CircularProgress size={16} style={{ color: "#fff" }} /> : null}
                    >
                        Save Team
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={updateteamModal} onClose={handleTeamModalClose} TransitionComponent={Transition} keepMounted fullWidth maxWidth="sm">
                <div className={classes.dialogHeader}>
                    <div className={classes.dialogTitleWrap}>
                        <div className={classes.dialogIconBadge}>
                            <EditOutlinedIcon />
                        </div>
                        <span className={classes.dialogTitleText}>Update Team</span>
                    </div>
                    <IconButton size="small" className={classes.dialogCloseBtn} onClick={handleTeamModalClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <DialogContent className={classes.dialogContent}>
                    {/* The dropdowns below are populated by four separate
                        fetches. A thin bar inside the dialog says so, instead of
                        the whole page sitting behind the global loader. */}
                    {refDataLoading && (
                        <div className={classes.dialogLoadingRow}>
                            <CircularProgress size={14} thickness={5} style={{ color: ORANGE_DARK }} />
                            Loading departments, managers and coverage…
                        </div>
                    )}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                select
                                fullWidth
                                className={classes.inputField}
                                value={selectedTeam}
                                label="Select Team"
                                onChange={setSelectedTeamvalues}
                                variant="outlined"
                            >
                                {teamList.filter(row => row.isActive).map((activeTeam, i) => (
                                    <MenuItem key={i + 1} value={activeTeam}>{activeTeam?.name}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                className={classes.inputField}
                                value={selectedManager}
                                label="Select Team Manager"
                                onChange={setSelectedTeamManagervalue}
                                variant="outlined"
                            >
                                {filteredManagers.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row}>{row?.name}</MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                className={classes.inputField}
                                value={selectedDGM}
                                label="Select Team DGM"
                                onChange={setSelectedTeamDgmValue}
                                variant="outlined"
                            >
                                {FilteredDGM.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row}>{row?.name}</MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                className={classes.inputField}
                                value={selectedAGM}
                                label="Select Team AGM"
                                onChange={setSelectedTeamAgmValue}
                                variant="outlined"
                            >
                                {filteredAGM.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row}>{row?.name}</MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                className={classes.inputField}
                                value={teamName}
                                onChange={(e) => setTeamName(e.target.value)}
                                label="Team Name"
                                type="text"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlSelect
                                classes={classes}
                                label="Select Location"
                                value={selectedCities}
                                onChange={getExperienceCenterByLocation}
                                options={dumpCities}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlSelect
                                classes={classes}
                                label="Select Experience Center"
                                value={selectedExpcenters}
                                onChange={getSelectedExpCenters}
                                options={dumpExpCenters}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ padding: "16px 24px 22px" }}>
                    <Button className={classes.cancelBtn} onClick={handleTeamModalClose}>Cancel</Button>
                    <Button
                        className={classes.submitBtn}
                        onClick={updateTeam}
                        disabled={savingTeam}
                        startIcon={savingTeam ? <CircularProgress size={16} style={{ color: "#fff" }} /> : null}
                    >
                        Update Team
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={viewTeamsUser} onClose={handleViewTeamModalClose} TransitionComponent={Transition} keepMounted fullWidth maxWidth="xs">
                <div className={classes.dialogHeader}>
                    <div className={classes.dialogTitleWrap}>
                        <div className={classes.dialogIconBadge}>
                            <GroupOutlinedIcon />
                        </div>
                        <span className={classes.dialogTitleText}>{teamName} - Members</span>
                    </div>
                    <IconButton size="small" className={classes.dialogCloseBtn} onClick={handleViewTeamModalClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <DialogContent className={classes.dialogContent}>
                    {teamUserList.length === 0 ? (
                        <div className={classes.emptyState} style={{ padding: "30px 0" }}>
                            <InboxOutlinedIcon className={classes.emptyIcon} />
                            <span className={classes.emptyTitle}>No active members in this team</span>
                        </div>
                    ) : (
                        teamUserList.map((row, i) => {
                            const avatarColor = getAvatarColor(row?.name)
                            return (
                                <div key={row?._id || i} className={classes.viewUserRow}>
                                    <div className={classes.avatarChip} style={{ backgroundColor: avatarColor.bg, color: avatarColor.fg, width: 30, height: 30, fontSize: 13 }}>
                                        {row?.name?.charAt(0)?.toUpperCase() || "?"}
                                    </div>
                                    {row?.name}
                                </div>
                            );
                        })
                    )}
                </DialogContent>
            </Dialog>
        </div>
    )

}

export default connect(null, { setSnackInfo })(ManageTeam)
